export default __webpack_public_path__ + "static/IBM-Plex-Mono-300italic-ea73e6fc66cd243f329b76d86b02cb53.woff";